/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 03/08/2026
 * @update 03/08/2026
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, Modal, ModalBody, ModalHeader, Row, TextInput } from 'diginet-core-ui/components';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W05F1424Actions from "../../../actions/w05/w05F2041/w05F2041-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";
import { Loading } from "../../common/loading/loadingCore";

const W05F2041PopUp = (props) => {
    const { openModal, onClose, paymentTermID, paymentMethodID, quotationID } = props;
    const [formLoading, setFormLoading] = useState(false);

    const [dataGrid, setDataGrid] = useState([]);
    useEffect(() => {
        loadPovDelivery();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadPovDelivery = () => {
        const params = {
            FormID: "W05F2041",
            DataType: "Load_PovDelivery",
            QuotationID: quotationID || "",
            LinkMaster: "",
            TranTypeID: "",
            PaymentTermID: paymentTermID || "",
            PaymentMethodID: paymentMethodID || "",
            ApprovalNote: "",
            OrderMethodID: ""

        }
        setFormLoading(true);
        props.W05F1424Actions.loadPovDelivery(params, (err, data) => {
            setFormLoading(false);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                setDataGrid(data);
            }
        });
    };

    return (
        <>
            <Modal open={openModal} size={'xl'} onClose={() => onClose && onClose(false)}>
                <ModalHeader title={Config.lang('Phieu_giao_hang')} />
                <ModalBody style={{ minHeight: 500 }}>
                    <Loading visible={formLoading} />
                    <Row>
                        <Col xs={12}>
                            <TextInput
                                label={Config.lang("So_phieu_giao_hang")}
                                viewType='outlined'
                                readOnly
                                value={dataGrid?.[0]?.VoucherNum}
                            />
                        </Col>
                        <Col xs={12}>
                            <GridContainer
                                totalItems={dataGrid.length}
                                dataSource={dataGrid}
                                hoverStateEnabled={true}
                                keyExpr={'InventoryID'}
                                typePaging={'normal'}
                                itemPerPage={50}
                                listPerPage={[50, 100, 150, 200]}
                                elementAttr={{ style: 'min-height: 420px' }}
                            >
                                <Column
                                    width={180}
                                    dataField={"InventoryID"}
                                    caption={Config.lang("Ma_hang")}
                                />
                                <Column
                                    minWidth={250}
                                    dataField={"InventoryName"}
                                    caption={Config.lang("Ten_hang")}
                                />
                                <Column
                                    width={100}
                                    dataField={"UnitName"}
                                    caption={Config.lang("Don_vi_tinh")}
                                />
                                <Column
                                    width={120}
                                    dataType={"number"}
                                    dataField={"Quantity"}
                                    caption={Config.lang("So_luong")}
                                />
                                <Summary>
                                    <TotalItem
                                        displayFormat={"{0}"}
                                        column={'Quantity'}
                                        valueFormat={(e) => Config.numberFormat(e, 8)}
                                        summaryType={"sum"}
                                    />
                                </Summary>
                            </GridContainer>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    )
};

export default connect(state => null,
    (dispatch) => ({
        W05F1424Actions: bindActionCreators(W05F1424Actions, dispatch),
    }))(W05F2041PopUp);
